import { ChangeEvent, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';

const StyledSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: theme.palette.primary.main,
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.primary.main,
  },
  '& .MuiSwitch-track': {
    borderRadius: 20,
    opacity: 0.3,
    backgroundColor: theme.palette.text.disabled,
  },
}));

type Props = {
  value?: boolean;
  onChange: (checked: boolean) => void;
};
export const InsightsToggle = ({ value, onChange }: Props) => {
  const [checked, setChecked] = useState(value ?? true);
  const theme = useTheme();

  const toggle = (
    _event: ChangeEvent<HTMLInputElement>,
    isChecked: boolean,
  ) => {
    setChecked(isChecked);
    onChange(isChecked);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          color: !checked
            ? theme.palette.text.primary
            : theme.palette.text.disabled,
          transition: 'color 0.2s ease',
        }}
      >
        Insights View
      </Typography>

      <StyledSwitch
        checked={checked}
        onChange={toggle}
        inputProps={{ 'aria-label': 'Toggle AI Summary' }}
      />

      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          color: checked
            ? theme.palette.text.primary
            : theme.palette.text.disabled,
          transition: 'color 0.2s ease',
        }}
      >
        AI Summary
      </Typography>
    </Box>
  );
};
